import { render, staticRenderFns } from "./dataQueryTemplate1.vue?vue&type=template&id=c1ad6b50&scoped=true"
import script from "./dataQueryTemplate1.vue?vue&type=script&lang=js"
export * from "./dataQueryTemplate1.vue?vue&type=script&lang=js"
import style0 from "./dataQueryTemplate1.vue?vue&type=style&index=0&id=c1ad6b50&prod&scoped=true&lang=css"
import style1 from "./dataQueryTemplate1.vue?vue&type=style&index=1&id=c1ad6b50&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ad6b50",
  null
  
)

export default component.exports